<template>
    <div class="preview-wrapper" :class="{ 'is-collapsed': collapsed }" :style="wrapperStyle">
        <!-- 收起/展开按钮（在面板左侧外部） -->
        <div class="preview-toggle" @click="collapsed = !collapsed">
            <i :class="collapsed ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
        </div>

        <div class="preview-panel">
            <div class="phone-frame" v-loading="loading">
                <div class="preview-header">
                    <div class="preview-app-toggle">
                        <span
                            class="preview-app-toggle-btn"
                            :class="{ 'is-active': previewAppType === 0 }"
                            @click="previewAppType = 0; getPreviewData()"
                        >中医大脑</span>
                        <span
                            class="preview-app-toggle-btn"
                            :class="{ 'is-active': previewAppType === 1 }"
                            @click="previewAppType = 1; getPreviewData()"
                        >望舌知康</span>
                    </div>
                </div>
                <div class="phone-screen" :class="{ 'is-wszk': previewAppType === 1 }" :style="phoneScreenStyle">
                    <div v-if="previewAppType === 0" class="preview-screen-title">
                        <div>数智(AI)健康服务系统</div>
                        <div class="preview-screen-subtitle">DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM</div>
                    </div>
                    <div class="phone-screen-content">
                        <!-- 中医大脑预览 -->
                        <template v-if="previewAppType === 0">
                            <template>
                                <div v-for="group in groupedPreviewData" :key="group.groupId" class="preview-group">
                                    <div class="preview-group-title">
                                        <img src="https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/icon/20260812114017098132ic_function_left.png" class="preview-group-title-icon" alt="" />
                                        <span>{{ group.groupName }}</span>
                                        <img src="https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/icon/20260812114017472776ic_function_right.png" class="preview-group-title-icon" alt="" />
                                    </div>
                                    <div v-for="item in group.items" :key="item.id" class="preview-menu-item">
                                        <img v-if="item.icon" :src="item.icon" class="preview-menu-icon" />
                                        <div v-else class="preview-menu-icon preview-menu-icon--placeholder"></div>
                                        <div class="preview-menu-text">
                                            <el-tooltip :content="item.title" placement="top" :disabled="!tipEnabled['ptitle-' + item.id]">
                                                <div class="preview-menu-title" @mouseenter="checkTip($event, 'ptitle-' + item.id)">{{ item.title }}</div>
                                            </el-tooltip>
                                            <el-tooltip v-if="item.subTitle" :content="item.subTitle" placement="top" :disabled="!tipEnabled['psub-' + item.id]">
                                                <div class="preview-menu-subtitle" @mouseenter="checkTip($event, 'psub-' + item.id)">{{ item.subTitle }}</div>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <!-- 望舌知康预览 -->
                        <template v-else>
                            <div class="wszk-menu-list">
                                <div v-for="item in flatPreviewItems" :key="item.id" class="wszk-menu-item">
                                    <img v-if="item.icon" :src="item.icon" class="wszk-menu-icon" />
                                    <div v-else class="wszk-menu-icon wszk-menu-icon--placeholder"></div>
                                    <div class="wszk-menu-text">
                                        <el-tooltip :content="item.title" placement="top" :disabled="!tipEnabled['wtitle-' + item.id]">
                                            <div class="wszk-menu-title" @mouseenter="checkTip($event, 'wtitle-' + item.id)">{{ item.title }}</div>
                                        </el-tooltip>
                                        <el-tooltip v-if="item.subTitle" :content="item.subTitle" placement="top" :disabled="!tipEnabled['wsub-' + item.id]">
                                            <div class="wszk-menu-subtitle" @mouseenter="checkTip($event, 'wsub-' + item.id)">{{ item.subTitle }}</div>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { list } from "@/api/appCompose";

export default {
    name: "MenuPreview",

    props: {
        merchantId: {
            type: String,
            default: "",
        },
        groupTypeList: {
            type: Array,
            default: () => [],
        },
        previewHeight: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            previewAppType: 0,
            previewData: [],
            loading: false,
            tipEnabled: {},
            collapsed: false,
        };
    },

    computed: {
        wrapperStyle() {
            return {
                height: this.previewHeight ? `${this.previewHeight}px` : "calc(80vh - 20px)",
            };
        },
        phoneScreenStyle() {
            const bgMap = {
                0: "https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/bg/20260812094654435525index.png",
                1: "https://yuyi-1301954635.cos.ap-guangzhou.myqcloud.com/bg/20260812140438357821wszk.jpg",
            };
            if (bgMap[this.previewAppType]) {
                return {
                    backgroundImage: `url('${bgMap[this.previewAppType]}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                };
            }
            return {};
        },
        groupedPreviewData() {
            const grouped = {};
            this.previewData
                .filter((item) => item.status === 1 && !item.useLog?.hideStatus)
                .sort((a, b) => (a.sort || 0) - (b.sort || 0))
                .forEach((item) => {
                    const gid = item.groupId;
                    if (!grouped[gid]) {
                        grouped[gid] = {
                            groupId: gid,
                            groupName: this.getGroupName(gid),
                            items: [],
                        };
                    }
                    grouped[gid].items.push(item);
                });
            return this.groupTypeList
                .filter((g) => grouped[g.groupId] && grouped[g.groupId].items.length > 0)
                .map((g) => grouped[g.groupId]);
        },
        flatPreviewItems() {
            return this.previewData
                .filter((item) => item.status === 1 && !item.useLog?.hideStatus)
                .sort((a, b) => (a.sort || 0) - (b.sort || 0));
        },
    },

    watch: {
        merchantId: {
            immediate: true,
            handler() {
                this.getPreviewData();
            },
        },
    },

    methods: {
        getGroupName(groupId) {
            return this.groupTypeList.find((el) => el.groupId == groupId)?.groupName || "-";
        },

        checkTip(event, key) {
            const el = event.currentTarget;
            this.$set(this.tipEnabled, key, el.scrollWidth > el.clientWidth);
        },

        getPreviewData() {
            this.loading = true;
            list({
                pageNum: 1,
                pageSize: 1000,
                appType: this.previewAppType,
                merchantId: this.merchantId || 0,
            })
                .then((res) => {
                    this.previewData = res.data.list || [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        refresh() {
            this.getPreviewData();
        },
    },
};
</script>

<style lang="scss" scoped>
.preview-wrapper {
    display: flex;
    align-items: stretch;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    align-self: flex-start;
}

.preview-toggle {
    width: 24px;
    height: 48px;
    align-self: center;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-right: none;
    border-radius: 6px 0 0 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 20;
    color: #909399;
    font-size: 12px;
    flex-shrink: 0;
    transition: color 0.2s;

    &:hover {
        color: #409eff;
        background: #ecf5ff;
    }
}

.preview-panel {
    width: 500px;
    padding-right: 10px;
    padding-bottom: 10px;
    flex-shrink: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: width 0.3s ease;

    .is-collapsed & {
        width: 0;
        padding-right: 0;
        overflow: hidden;
    }
}

.preview-header {
    position: absolute;
    top: 18px;
    left: 18px;
    z-index: 10;
    display: flex;
    align-items: center;
}

.preview-app-toggle {
    display: flex;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
}

.preview-app-toggle-btn {
    padding: 4px 12px;
    font-size: 12px;
    color: #606266;
    cursor: pointer;
    background: #fff;
    transition: all 0.2s;
    user-select: none;

    & + & {
        border-left: 1px solid #dcdfe6;
    }

    &.is-active {
        background: #409eff;
        color: #fff;
    }

    &:hover:not(.is-active) {
        color: #409eff;
    }
}

.phone-frame {
    background: #fff;
    border-radius: 16px;
    box-shadow: 2px 1px 8px rgba(0, 0, 0, 0.1);
    padding: 8px;
    border: 2px solid #e4e7ed;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
}

.phone-screen {
    background: #f5f7fa;
    border-radius: 10px;
    padding: 12px 10px 0;
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.phone-screen-content {
    flex: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
}

.preview-screen-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #313131;
    padding: 28px 0 20px;
    letter-spacing: 1px;
}

.preview-screen-subtitle {
    font-size: 6px;
    font-weight: 400;
    color: #666666;
    letter-spacing: 0.5px;
}

.preview-group {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px;
    position: relative;
    background: #fff;
    clip-path: polygon(
        8px 0, calc(100% - 8px) 0,
        100% 8px, 100% calc(100% - 8px),
        calc(100% - 8px) 100%, 8px 100%,
        0 calc(100% - 8px), 0 8px
    );

    &::after {
        content: '';
        position: absolute;
        inset: 1px;
        background: linear-gradient(to bottom, rgba(219, 243, 255, 1), rgba(213, 228, 246, 1));
        clip-path: polygon(
            7px 0, calc(100% - 7px) 0,
            100% 7px, 100% calc(100% - 7px),
            calc(100% - 7px) 100%, 7px 100%,
            0 calc(100% - 7px), 0 7px
        );
        z-index: -1;
    }
}

.preview-group-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    color: #313131;
    margin-bottom: 2px;
    text-align: center;
}

.preview-group-title-icon {
    width: auto;
    height: 6px;
    flex-shrink: 0;
}

.preview-menu-item {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 8px 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    width: calc((100% - 12px) / 3);
    box-sizing: border-box;
}

.preview-menu-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    flex-shrink: 0;
    object-fit: cover;

    &--placeholder {
        background: #e4e7ed;
        // display: flex;
        // align-items: center;
        // justify-content: center;

        // &::after {
        //     content: '📱';
        //     font-size: 14px;
        // }
    }
}

.preview-menu-text {
    margin-left: 6px;
    flex: 1;
    min-width: 0;
}

.preview-menu-title {
    font-size: 12px;
    color: #303133;
    font-weight: 500;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.preview-menu-subtitle {
    font-size: 11px;
    color: #909399;
    margin-top: 1px;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

// 望舌知康预览样式（与中医大脑完全隔离）
.phone-screen.is-wszk {
    min-height: 630px;
    .phone-screen-content {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .wszk-menu-list {
        margin-top: auto;
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
        max-height: 20%;
        overflow-y: auto;
        padding: 20px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            display: none;
        }

        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .wszk-menu-item {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.92);
        border-radius: 8px;
        padding: 8px;
        box-sizing: border-box;
    }

    .wszk-menu-icon {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        flex-shrink: 0;
        object-fit: cover;

        &--placeholder {
            background: #e4e7ed;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
                content: '📱';
                font-size: 14px;
            }
        }
    }

    .wszk-menu-text {
        margin-left: 6px;
        flex: 1;
        min-width: 0;
    }

    .wszk-menu-title {
        font-size: 12px;
        color: #303133;
        font-weight: 500;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .wszk-menu-subtitle {
        font-size: 11px;
        color: #666666;
        margin-top: 1px;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
